"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_dynamic_controls_metadata_1 = require("@synisys/idm-dynamic-controls-metadata");
var idm_ng_controls_1 = require("@synisys/idm-ng-controls");
var Observable_1 = require("rxjs/Observable");
var Subject_1 = require("rxjs/Subject");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var operators_1 = require("rxjs/operators");
var idm_dynamic_layout_interpreter_1 = require("@synisys/idm-dynamic-layout-interpreter");
var related_entity_config_1 = require("../model/related-entity-config");
var related_entity_column_config_1 = require("../model/related-entity-column-config");
var custom_calculation_service_1 = require("../../../shared/services/api/custom-calculation.service");
var RelatedEntitySettingsComponent = /** @class */ (function (_super) {
    __extends(RelatedEntitySettingsComponent, _super);
    function RelatedEntitySettingsComponent(communicationService, kbService, customCalculationService) {
        var _this = _super.call(this, communicationService) || this;
        _this.communicationService = communicationService;
        _this.kbService = kbService;
        _this.customCalculationService = customCalculationService;
        _this._destroy$ = new Subject_1.Subject();
        _this._selectedMetaCategories = [];
        _this._relatedEntityConfigs = [];
        _this._availableColumns = new Map();
        _this._availableMetaCategories = new Set();
        _this._isReady = false;
        return _this;
    }
    Object.defineProperty(RelatedEntitySettingsComponent.prototype, "state", {
        set: function (state) {
            this._state = state;
        },
        enumerable: true,
        configurable: true
    });
    RelatedEntitySettingsComponent.prototype.ngOnInit = function () {
        var _this = this;
        var relatedEntityData = this._state['relatedEntityConfigs'];
        var metaCategories$ = this.kbService.getMainEntityMetaCategories();
        var availableColumns$ = relatedEntityData ? this.loadSelectedCategoriesAvailableColumns(relatedEntityData) : Observable_1.Observable.of(new Map());
        Observable_1.Observable.zip(metaCategories$, availableColumns$)
            .pipe(operators_1.takeUntil(this._destroy$))
            .subscribe(function (data) {
            _this._availableMetaCategories = data[0];
            _this._availableColumns = data[1];
            _this._relatedEntityConfigs = relatedEntityData ? relatedEntityData : [new related_entity_config_1.RelatedEntityConfig()];
            if (relatedEntityData) {
                _this.checkForSelectedMetaCategory();
            }
            _this._isReady = true;
        });
    };
    RelatedEntitySettingsComponent.prototype.onMetaCategorySelected = function (selectedMetaCategory, index) {
        var _this = this;
        this._relatedEntityConfigs[index].metaCategory = selectedMetaCategory;
        this._relatedEntityConfigs[index].columns = [];
        this._selectedMetaCategories.push(selectedMetaCategory);
        this.loadCategoryAvailableColumns(selectedMetaCategory.getMetaCategoryId().getSystemName()).subscribe(function (columns) {
            _this._availableColumns.set(selectedMetaCategory.getMetaCategoryId().getSystemName(), columns);
        });
        this.changeCommunicationSettings();
    };
    RelatedEntitySettingsComponent.prototype.onSelectedMetaCategoryTitleChange = function (title, index) {
        this.relatedEntityConfigs[index].title = title;
        this.changeCommunicationSettings();
    };
    RelatedEntitySettingsComponent.prototype.onMetaFieldsSelected = function (columns, index) {
        this.relatedEntityConfigs[index].columns = columns;
        this.changeCommunicationSettings();
    };
    RelatedEntitySettingsComponent.prototype.onShowNavigationButtonChanged = function (value, index) {
        this.relatedEntityConfigs[index].showNavigationButton = value;
        this.changeCommunicationSettings();
    };
    RelatedEntitySettingsComponent.prototype.addNewCategory = function () {
        this._relatedEntityConfigs.push(new related_entity_config_1.RelatedEntityConfig());
    };
    RelatedEntitySettingsComponent.prototype.deleteConfig = function (index) {
        this._relatedEntityConfigs.splice(index, 1);
        this._relatedEntityConfigs = this._relatedEntityConfigs.slice();
        this.changeCommunicationSettings();
    };
    RelatedEntitySettingsComponent.prototype.loadSelectedCategoriesAvailableColumns = function (relatedEntityData) {
        var _this = this;
        var allColumns = this.getSelectedCategories(relatedEntityData).map(function (category) {
            return _this.loadCategoryAvailableColumns(category).pipe(operators_1.map(function (columns) {
                return { category: category, columns: columns };
            }));
        });
        return Observable_1.Observable.zip.apply(Observable_1.Observable, allColumns).pipe(operators_1.map(function (data) {
            var result = new Map();
            data.forEach(function (item) {
                result.set(item.category, item.columns);
            });
            return result;
        }));
    };
    RelatedEntitySettingsComponent.prototype.getSelectedCategories = function (relatedEntityData) {
        return Array.from(new Set(relatedEntityData.map(function (value) { return value && value.metaCategory['metaCategoryId']['systemName']; }))).filter(function (value) { return !!value; });
    };
    RelatedEntitySettingsComponent.prototype.loadCategoryAvailableColumns = function (metaCategoryName) {
        var _this = this;
        var standardColumns$ = this.kbService.getMetaFields(metaCategoryName);
        var customColumns$ = this.customCalculationService.getCustomCalculations(this.category, metaCategoryName);
        return Observable_1.Observable.zip(standardColumns$, customColumns$).pipe(operators_1.map(function (data) {
            var metaFields = data[0];
            var customColumns = data[1];
            var availableColumns = [];
            // fill standard columns
            metaFields.forEach(function (metaField) {
                if (metaField.getType() !== idm_kb_service_client_js_1.MetaFieldType.SUB_ENTITY) {
                    var title = metaField.getDisplayNameMultilingual().getValue(_this.currentLanguageId);
                    var key = metaField.getSystemName();
                    availableColumns.push(new related_entity_column_config_1.RelatedEntityColumnConfig(title, key));
                }
            });
            // fill custom columns
            availableColumns.push.apply(availableColumns, customColumns.map(function (value) {
                return new related_entity_column_config_1.RelatedEntityColumnConfig(value.title, value.key, true, value.participants);
            }));
            return availableColumns;
        }));
    };
    RelatedEntitySettingsComponent.prototype.checkForSelectedMetaCategory = function () {
        var _this = this;
        var array = Array.from(this.availableMetaCategories);
        this.relatedEntityConfigs.forEach(function (data, index) {
            array.forEach(function (availableMetaCategory) {
                if (data.metaCategory['metaCategoryId']['systemName'] === availableMetaCategory['metaCategoryId']['systemName']) {
                    _this.selectedMetaCategories.push(availableMetaCategory);
                    _this.checkForSelectedMetaFields(availableMetaCategory['metaCategoryId']['systemName']);
                }
            });
        });
    };
    RelatedEntitySettingsComponent.prototype.checkForSelectedMetaFields = function (metaCategory) {
        var _this = this;
        this.relatedEntityConfigs.forEach(function (data) {
            if (data.metaCategory['metaCategoryId']['systemName'] === metaCategory) {
                var selectedMetaFields_1 = [];
                data.columns.forEach(function (selectedColumn) {
                    _this.availableColumns.get(metaCategory).forEach(function (availableColumn) {
                        if (selectedColumn.title === availableColumn.title) {
                            selectedMetaFields_1.push(availableColumn);
                        }
                    });
                });
                data.columns = selectedMetaFields_1;
            }
        });
    };
    RelatedEntitySettingsComponent.prototype.changeCommunicationSettings = function () {
        var data = {
            bindings: {},
            state: this.getState(),
            fields: {}
        };
        this.communicationService.parentSubject.next(new idm_dynamic_controls_metadata_1.CommunicationData(idm_dynamic_controls_metadata_1.CommunicationKey.SETTINGS_CHANGED, data));
    };
    RelatedEntitySettingsComponent.prototype.getState = function () {
        return {
            relatedEntityConfigs: this.relatedEntityConfigs,
            tooltipSettings: this._tooltipSettings
                ? this._tooltipSettings.toJsonString()
                : undefined,
        };
    };
    Object.defineProperty(RelatedEntitySettingsComponent.prototype, "availableMetaCategories", {
        get: function () {
            return this._availableMetaCategories;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RelatedEntitySettingsComponent.prototype, "relatedEntityConfigs", {
        get: function () {
            return this._relatedEntityConfigs;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RelatedEntitySettingsComponent.prototype, "selectedMetaCategories", {
        get: function () {
            return this._selectedMetaCategories;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RelatedEntitySettingsComponent.prototype, "isReady", {
        get: function () {
            return this._isReady;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RelatedEntitySettingsComponent.prototype, "availableColumns", {
        get: function () {
            return this._availableColumns;
        },
        enumerable: true,
        configurable: true
    });
    RelatedEntitySettingsComponent.prototype.ngOnDestroy = function () {
        this._destroy$.next(true);
        this._destroy$.complete();
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], RelatedEntitySettingsComponent.prototype, "category", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], RelatedEntitySettingsComponent.prototype, "controlLabel", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], RelatedEntitySettingsComponent.prototype, "languages", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], RelatedEntitySettingsComponent.prototype, "currentLanguageId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], RelatedEntitySettingsComponent.prototype, "formType", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], RelatedEntitySettingsComponent.prototype, "state", null);
    RelatedEntitySettingsComponent = __decorate([
        core_1.Component({
            
            selector: 'ejustice-related-entity-settings',
            template: require('./related-entity-settings.component.html'),
            styles: [require('./related-entity-settings.component.css')],
        }),
        idm_dynamic_controls_metadata_1.ControlMetadata({
            template: "<ejustice-related-entity-settings\n                    [category]=\"%{category}\"\n                    [state]=\"%{state}\"\n                    [controlLabel]=\"%{controlLabel}\"\n                    [languages]=\"%{languages}\"\n                    [currentLanguageId]=\"%{currentLanguageId}\"\n                    [formType]=\"%{formType}\">\n                </ejustice-related-entity-settings>"
        }),
        __metadata("design:paramtypes", [idm_dynamic_controls_metadata_1.CommunicationService,
            idm_kb_service_client_js_1.KbService,
            custom_calculation_service_1.CustomCalculationService])
    ], RelatedEntitySettingsComponent);
    return RelatedEntitySettingsComponent;
}(idm_ng_controls_1.BaseSettings));
exports.RelatedEntitySettingsComponent = RelatedEntitySettingsComponent;
//# sourceMappingURL=related-entity-settings.component.js.map